const i = {
  informative: "info",
  neutral: "info",
  positive: "checkCircle",
  warning: "exclamation",
  blocking: "exclamation"
};
export {
  i as ICONS_BY_TYPE
};
